class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);



// Ensure the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {

    // Function to autoplay all videos
    function autoplayVideos() {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();  // Start playing all videos
        });
    }

    // Function to pause all videos after DOM and APIs are fully loaded
    function pauseVideos() {
        const videos = document.querySelectorAll('video');
        videos.forEach(video => {
            video.pause();  // Pause all videos
        });
    }

    // Create an IntersectionObserver to load videos lazily when in view
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;
                video.pause();  // Play the video when it enters the viewport
                observer.unobserve(video);  // Stop observing once the video is in view
            } else {
                const video = entry.target;
                video.pause();  // Pause the video when it's out of view
            }
        });
    }, {
        threshold: 0.5  // Video will start playing when 50% of it is visible in the viewport
    });

    // Get all videos and observe them for intersection
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
        observer.observe(video);
    });

    // Autoplay the videos once the DOM is loaded
    autoplayVideos();

    // Pause videos after everything is loaded (you can implement logic to detect API load here)
    window.addEventListener('load', function() {
        // Assuming API calls are complete here
        pauseVideos();
    });
});